import styled from 'styled-components'

export const ContainerChooseBarrier = styled.div`
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 600px;

  @media (max-height: 990px) {
    height: 560px;
  }

  @media (max-height: 900px) {
    padding-top: 20px;
    height: 470px;
  }

  @media (max-height: 750px) {
    height: 400px;
  }

  @media (max-height: 600px) {
    height: 370px;
  }
`

export const ImageToSnapshot = styled.img`
  width: 40em;

  @media (max-height: 900px) {
    width: 30em;
  }

  @media (max-height: 600px) {
    width: 20em;
  }
`
